import React from "react";
import { RootStateOrAny, useSelector } from "react-redux";

import * as table from "./tabColumns";
import HistoryTable from "./table";

type HistoryProps = {
	id: number | string;
	historyKey: string;
	classNameHeader?: string;
	useHistoryListQuery: Function;
	getRendererByKey: Function;
};

const History = ({
	id,
	historyKey,
	getRendererByKey,
	useHistoryListQuery,
	classNameHeader,
}: HistoryProps) => {
	const currentUser = useSelector((state: RootStateOrAny) => state.user);

	const tableColumns = [
		table.dateTimeColumn(),
		table.userColumn({ currentUser }),
		table.historyActionColumn(getRendererByKey),
	];

	return (
		<HistoryTable
			id={id}
			classNameHeader={classNameHeader}
			historyKey={historyKey}
			columns={tableColumns}
			getHistoryList={useHistoryListQuery}
		/>
	);
};

export default History;
